import React from 'react';
import Maps from '../Maps/Maps';
import { Modal } from 'react-bootstrap';
import MapsV1 from '../Maps/MapsV1';

function FullScreenModal({ show, setShow }) {

    return (
        <Modal show={show} fullscreen={true} onHide={setShow}>
            <Modal.Header closeButton>
                <Modal.Title>Google Maps</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Maps setShow={setShow} />
                {/* <MapsV1 setShow={setShow} /> */}
            </Modal.Body>
        </Modal>
    );
}

export default FullScreenModal;